/**
 * @file: description
 * @author: yangqianjun
 * @Date: 2020-01-03 13:22:03
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-07-08 21:06:58
 */
import React, { useState, useRef, useEffect } from 'react';
import MarkdownIt from 'markdown-it';
import hljs from 'highlight.js';
import SFCCatelog from './SFCCatelog';
const xss = require('xss');

type Props = ISFCMarkdownProps;
export interface ISFCMarkdownProps {
  /** 值 */
  val?: string;
  /** 是否显示目录 */
  showCatelog?: boolean;
  subconChange?: (val: string) => void;
}

export function SFCMarkdown(props: Props) {
  const { val = '', showCatelog, subconChange } = props;
  const [markdown] = useState(
    new MarkdownIt({
      highlight: (str, lang) => {
        if (lang && hljs.getLanguage(lang)) {
          try {
            return hljs.highlight(lang, str).value;
          } catch (e) {
            console.warn(e);
          }
        }
        return ''; // 使用额外的默认转义
      }
    })
  );
  const editCon = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (subconChange) {
      const vdom = document.createElement('div');

      vdom.innerHTML = markdown.render(val || '');

      subconChange(vdom.textContent || '');
    }
  }, [markdown, subconChange, val]);

  const titClick = (index: number) => {
    const { current: editDom } = editCon;

    if (editDom) {
      const target = editDom.querySelectorAll('h1,h2,h3')[index];

      target.scrollIntoView({
        block: 'center'
      });
    }
  };

  const renderStr = markdown.render(val || '');

  return (
    <>
      <div className="ql-container">
        <div
          className="ql-editor"
          dangerouslySetInnerHTML={{ __html: xss(renderStr) }}
          ref={editCon}
        />
      </div>
      {showCatelog && <SFCCatelog val={renderStr} itemClick={titClick} />}
    </>
  );
}

export default SFCMarkdown;
